// src/components/flight-data/DroppableColumn.js
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Box, Typography } from '@mui/material';
import FlightTile from './FlightTile';

// Add `onRemoveFlight` and `onFlightEdit` to the props
function DroppableColumn({ id, title, flights = [], titleColor = '#fff', params, onRemoveFlight, onFlightEdit, hideColdGates = false, onPinClick, availablePinPositions, onSplitLocal, onGhostConfirm, onGhostDismiss }) {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  const style = {
    backgroundColor: isOver ? 'rgba(0, 128, 0, 0.2)' : undefined,
    border: isOver ? '2px dashed #4CAF50' : '1px dashed grey',
    transition: 'border-color 0.2s, background-color 0.2s',
    position: 'relative',
    zIndex: 1,
  };

  return (
    <Box className="board-column" sx={{
      height: '100%',
      p: 1,
      backgroundColor: 'rgba(0,0,0,0.2)',
      borderRadius: 1,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      zIndex: 1,
    }}>
      <Typography variant="h6" sx={{ textAlign: 'center', mb: 1, color: titleColor }}>
        {title}
      </Typography>
      <Box
        ref={setNodeRef}
        p={1}
        mt={1}
        mb={1}
        sx={{
          ...style,
          borderRadius: 1,
          flex: 1, // Take up all remaining space
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Pass the function from this component's props to the tile's `onRemove` and `onFlightEdit` props */}
        {flights.filter(flight => flight && flight.uniqueId).map(flight => (
          <FlightTile
            key={flight.uniqueId}
            flight={flight}
            sourceColumnId={id}
            params={params || {}}
            onRemove={onRemoveFlight}
            onFlightEdit={onFlightEdit}
            hideColdGates={hideColdGates}
            onPinClick={onPinClick}
            availablePinPositions={availablePinPositions}
            onSplitLocal={onSplitLocal}
            onGhostConfirm={onGhostConfirm}
            onGhostDismiss={onGhostDismiss}
          />
        ))}
        {flights.length === 0 && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}>
            <Typography sx={{ color: 'grey', fontStyle: 'italic' }}>
              Drag flights here
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default DroppableColumn;
